import { defineComponent as _defineComponent } from 'vue'
import OzIconButton, {
  OzIconButtonColorScheme,
  OzIconButtonSizePreset,
} from '@@/library/v4/components/OzIconButton.vue'
import { useWindowSizeStore } from '@@/pinia/window_size'
import { useLandsideQuoteModalStore } from '@@/pinia/landside_quote_modal'
import OzScreenSizeAwareCenterModal from '@@/library/v4/components/OzScreenSizeAwareCenterModal.vue'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideQuoteModal',
  setup(__props) {

const { isPhone, windowHeight } = storeToRefs(useWindowSizeStore())
const quoteModalStore = useLandsideQuoteModalStore()
const { isQuoteModalOpen } = storeToRefs(quoteModalStore)
const { closeQuoteModal } = quoteModalStore

const FORM_ID = 'padlet-backpack-quotation-new-pricing-prod'

onMounted(() => {
  const script = document.createElement('script')
  script.src = 'https://paperform.co/__embed'
  script.async = true
  document.body.appendChild(script)
})

return { __sfc: true,isPhone, windowHeight, quoteModalStore, isQuoteModalOpen, closeQuoteModal, FORM_ID, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzScreenSizeAwareCenterModal }
}

})